// extracted by mini-css-extract-plugin
module.exports = {"mainDiv":"page_mainDiv__0xMPG","labelsDiv":"page_labelsDiv__LbR1T","mainBox":"page_mainBox__U2KW_","insideBox":"page_insideBox__lqh3X"};